import React from "react";
import Badge from "../elements/Badge";
import Resume from "../../../resume.json";

function AboutMe() {
  const summary = Resume.basics.summary;
  return (
    <section className="section" id="intro">
      <div className="container has-text-centered">
        <figure className="image container is-180x180">
          <img
            width="180px"
            height="180px"
            src={Resume.basics.picture}
            alt={Resume.basics.name}
            className="is-rounded"
            onError={(e)=>{e.target.onerror = null; e.target.src=Resume.basics.x_pictureFallback}}
          />
        </figure>
        <p className="content_subtitle is-4 has-text-white">
          {Resume.basics.x_title}
        </p>
        <div className="is-5 has-text-white has-text-weight-light summary-text content_content">
          {buildSummaries(summary)}
        </div>
        <div className="container interests">
          <div className="field is-grouped is-grouped-multiline has-text-centered">
            {Resume.interests.map((value, index) => {
              return (
                <Badge key={index} text={value.name} faIcon={value.x_icon} />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

function buildSummaries(summaries) {
  let colored = [11, 20, 21, 22, 23, 35, 45, 46, 47, 48, 49, 50, 86, 129, 161, 162, 194, 195, 196, 216];
  let result = [];
  let words = [];
  let counter = 0;
  let count_words = 0;
  Object.entries(summaries).forEach(([key, value]) => {
    console.log(key, value)
    let words_array = value.replace("-&+$?.@"," ").split(" ");
    words = [];
    console.log('len', words_array.length)
    for (let i = 0 ; i < words_array.length ; i++){
      count_words++;
      let canme = ''
      if (colored.includes(count_words)) canme += "color_text"
      console.log(count_words, words_array[i])
      if (words_array[i] === 'contact') {
        words.push(
          <span key={count_words} className={canme} style={{display: "inline"}}>
            <a href='#contact'>
              {words_array[i]}{" "}
            </a>
          </span>
        )
      } else {
        words.push(
          <span key={count_words} className={canme} style={{display: "inline"}}>
            {words_array[i]}{" "}
          </span>
        )
      }
    }
    // Object.entries(value).forEach(([key2, word_value]) => {
    //   console.log(word_value)
    //   count_words++;
    //   let canme = ''
    //   if (colored.includes(count_words)){
    //     canme += "color_text"
    //   }
    //   words.push(
    //     <div key={count_words} className={canme} style={{display: "inline"}}>
    //       {word_value}
    //     </div>
    //   )
    // });
    result.push(
      <p key={counter}>
        {words}
      </p>
    );
    counter++;
  });
  return result;
}


export default AboutMe;

